export const SEATS_FREE_TO_PRO_TOUCHLESS_FLOW_GATE = 'CBX:SeatsFreeToProTouchlessFlow';
export const SEATS_FREE_TO_STARTER_TOUCHLESS_FLOW_GATE = 'CBX:SeatsFreeToStarterTouchlessFlow';
export const CBX_FEATURE_STORE_BUSINESS_OBJECTIVES_GATE = 'CBX:FeatureStoreBusinessObjectives';
export const CBX_FEATURE_STORE_DEFAULT_CONTENT_GATE = 'CBX:FeatureStoreDefaultContent';
export const CBX_CLEARBIT_GATE = 'CBX:Clearbit';
export const GROWTH_CALCULATED_FEATURES_TRANSLATED_GATE = 'Growth:CalculatedFeaturesTranslated';
export const CBX_ADD_ADDITIONAL_CONTACTS_SEATS_TOUCHLESS_FLOW = 'CBX:AddAdditionalContactsSeatsTouchlessFlow';